import { AxiosError } from 'axios';
import { useState } from 'react';
import toast from 'react-hot-toast';

import { ErrorHttpResponse, HttpConfig, SuccessHttpResponse } from '../../../models/https';
import useHttps from '../../useHttps';

const useViewBusinessProfile = () => {
    const request = useHttps();
    const [loading, setLoading] = useState(false);
    const [businessProfileData, setBusinessProfileData] = useState<Record<string, any> | null>(null);

    const onViewBusinessProfileError = (err: AxiosError<ErrorHttpResponse>) => {
        toast.error(
            err?.response?.data?.message ?? 'Something went wrong while fetching business profile information.',
        );
    };

    const onViewBusinessProfileSuccess = ({
        data,
        message,
    }: SuccessHttpResponse<any>) => {
        setBusinessProfileData(data);
    };

    const viewBusinessProfile = (companyId: any) => {
        const url: HttpConfig = {
            url: `ba/v1/company/${companyId}/kyc/business-profile`,
            method: 'get',
        };

        request(url, onViewBusinessProfileSuccess, setLoading, onViewBusinessProfileError);
    };

    return { viewBusinessProfile, loading, businessProfileData };
};

export default useViewBusinessProfile;
